import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { ISvcUserAvatar, UserAvatarSize } from './interfaces/svc-user-avatar.interface';
import { normalizeUserAvatarSize } from './svc-user-avatar-helpers';

@Component({
  selector: 'svc-user-avatar',
  templateUrl: './svc-user-avatar.component.html',
  styleUrls: ['./svc-user-avatar.component.scss'],
})
export class SvcUserAvatarComponent implements OnInit, OnChanges {
  @Input() info: ISvcUserAvatar;
  @Input('border-color') borderColor: string = 'white';
  @Input() highDefinition = false;

  public fontSize: number;
  public size: number;
  public initials: string;

  public UserAvatarSize = UserAvatarSize;
  public isHundredPercentSize = false;
  private wasInitialized = false;

  ngOnInit(): void {
    if (!this.info) this.info = <ISvcUserAvatar>{};
    const names =
      this.info?.name
        ?.replace(/\([^)]*\)|[^a-zA-Z 0-9]/g, '')
        .trim()
        .split(' ') ?? [];
    const firstName = names?.length ? names[0].substring(0, 1) : '';
    const lastName = names?.length > 1 ? names[names.length - 1].substring(0, 1) : '';
    this.initials = `${firstName}${lastName}`.toUpperCase();
    this.size = normalizeUserAvatarSize(this.info?.size);
    this.fontSize = this.size * 0.5;
    this.wasInitialized = true;
    this.isHundredPercentSize = this.info?.size < 0;
  }

  ngOnChanges(): void {
    if (this.wasInitialized) {
      this.ngOnInit();
    }
  }

  protected onImgLoadError(): void {
    const newInfo = { ...this.info };
    if (this.highDefinition && this.info?.pictureHQ) {
      newInfo.pictureHQ = null;
      if (this.info?.pictureHQ === this.info?.picture) {
        newInfo.picture = null;
      }
    } else {
      newInfo.picture = null;
    }
    this.info = newInfo;
  }
}
